import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Panel, Glyphicon, Row, Col } from "react-bootstrap";
import ReportingChart from "./summary/ReportingChart";
import TripsChart from "./summary/TripsChart";
import AlertsChart from "./summary/AlertsChart";
import UsersChart from "./summary/UsersChart";

import "./Home.css";

export default class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
    };
  }

  renderLander() {
    return (
      <div className="lander">
        <h1>Fleet App</h1>
        <p>A fleet manager</p>
        <div>
          <Link to="/login" className="btn btn-info btn-lg">
            Login
          </Link>
        </div>
      </div>
    );
  }

  renderUserHome() {
	return (
	  <div>
		<Panel>
		  <Panel.Body><Glyphicon glyph="info-sign" /> Aquí encontrarás un resumen del estado de tus vehículos, si quieres más detalle puedes navegar en los menús disponibles.</Panel.Body>
		</Panel>
		<Row>
	      <Col sm={6}>
	        <ReportingChart />
	      </Col>
	      <Col sm={6}>
	        <TripsChart />
	      </Col>
	    </Row>
	    <AlertsChart />
	    <UsersChart />
	  </div>
	);
  }
  render() {
    return (
      <div className="Home">
        {
        	this.props.isAuthenticated
        	?
        	this.renderUserHome()
        	:
        	this.renderLander()
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/containers/Home.js